import React, { useState } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';

const BeaconScoresSection = ({ onUpdate, boostInput = false }) => {
  const [currentBeaconScore, setCurrentBeaconScore] = useState('');
  const [currentBeaconOperator, setCurrentBeaconOperator] = useState('');
  const [currentBeaconThreshold, setCurrentBeaconThreshold] = useState('');
  const [boost, setBoost] = useState(1);

  const operatorOptions = [
    { id: '<=', label: '<=' },
    { id: '>=', label: '>=' }
  ];

  const beaconScoreOptions = [
    { id: 'score_like', label: 'Score Like' },
    { id: 'score_share', label: 'Score Share' },
    { id: 'score_comment', label: 'Score Comment' },
    { id: 'score_reaction', label: 'Score Reaction' }
  ];

  const handleBeaconScoreChange = (event) => {
    setCurrentBeaconScore(event.target.value);
    
    // Set default operator and threshold for all beacon models
    setCurrentBeaconOperator('>=');
    setCurrentBeaconThreshold('0.5');
  };

  const handleBeaconScoresAction = (actionType) => {
    if (!currentBeaconScore || !currentBeaconOperator || !currentBeaconThreshold) return;
    
    const beaconThresholdFloat = parseFloat(currentBeaconThreshold);
    if (isNaN(beaconThresholdFloat) || beaconThresholdFloat < 0 || beaconThresholdFloat > 1) return;
    
    const updateData = {
      action: actionType,
      filter: 'numeric',
      field: currentBeaconScore,
      value: beaconThresholdFloat,
      operator: currentBeaconOperator,
    };
    
    // Add boost value if boostInput is enabled
    if (boostInput) {
      updateData.boost = boost;
    }
    
    onUpdate(updateData);
    
    // Reset after adding
    setCurrentBeaconScore('');
    setCurrentBeaconOperator('');
    setCurrentBeaconThreshold('');
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <FormControl sx={{ flex: 1 }}>
          <InputLabel>Score</InputLabel>
          <Select
            value={currentBeaconScore}
            label="Score"
            onChange={handleBeaconScoreChange}
          >
            {beaconScoreOptions.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 100 }}>
          <InputLabel>Operator</InputLabel>
          <Select
            value={currentBeaconOperator}
            label="Operator"
            onChange={(e) => setCurrentBeaconOperator(e.target.value)}
          >
            {operatorOptions.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Threshold (0-1)"
          type="number"
          value={currentBeaconThreshold}
          onChange={(e) => setCurrentBeaconThreshold(e.target.value)}
          inputProps={{ min: 0, max: 1, step: 0.01 }}
          sx={{ flex: 1 }}
        />
      </Box>
      
      {boostInput && (
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="Boost"
          type="number"
          value={boost}
          onChange={(e) => setBoost(parseFloat(e.target.value) || 1)}
          inputProps={{ min: 0, step: 0.1 }}
        />
      )}
      
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleBeaconScoresAction('include')}
          disabled={!currentBeaconScore || !currentBeaconOperator || !currentBeaconThreshold}
        >
          <AddIcon />
        </Button>
        
        {boostInput && (
          <Button
            variant="contained"
            color="success"
            onClick={() => handleBeaconScoresAction('boost')}
            disabled={!currentBeaconScore || !currentBeaconOperator || !currentBeaconThreshold}
          >
            <TrendingUpIcon />
          </Button>
        )}
        
        <Button
          variant="contained"
          color="error"
          onClick={() => handleBeaconScoresAction('exclude')}
          disabled={!currentBeaconScore || !currentBeaconOperator || !currentBeaconThreshold}
        >
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default BeaconScoresSection;

